<template>
  <LValidationForm v-model="validationResult" @update:model-value="onValidationUpdate">
    <template v-for="(field, i) in currentStep?.form_schema" :key="field.config.field_id || i">
      <div v-if="!field.config.hide" class="lnx-row" :class="field.config.row_class">
        <DynamicFormField
          :field="field"
          :components="components"
          :state="state"
          @update:model-value="handleFieldUpdate"
          @open-modal="showModal"
        />
      </div>
    </template>
  </LValidationForm>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useFormStore } from '@/stores/formStore'
import { useGlobalStore } from '@/stores/globalStore'
import { DynamicFormService } from '@/services/dynamic-form.service'
import { LValidationForm } from '@wgg.hyve/linexo-form-validator'
import DynamicFormField from '@/components/atoms/forms/DynamicFormField.vue'

const { currentStep } = storeToRefs(useFormStore())

const { checkFormFieldChanged, validateFormSchemaStatus } = useFormStore()
const { showModal } = useGlobalStore()

const state = reactive({ mounted: false })
const components = DynamicFormService.getComponents()
const validationResult = ref<any>(null)

const onValidationUpdate = (value: any) => {
  validateFormSchemaStatus(!!value?.isValid)
}

const handleFieldUpdate = ({ stepId, fieldId, value }: { stepId: number; fieldId: string; value: any }) => {
  if (state.mounted) {
    checkFormFieldChanged({ stepId, fieldId, value })
  }
}

onMounted(() => {
  state.mounted = true
})
</script>
